"use strict";


var LOTTIE_RUNNED = false;
var MAIN=document.getElementById("main");
var DUPLICATOR = new Duplicator(MAIN);

document.getElementById("menu-btn").addEventListener("click", function () {

    document.querySelector("body").classList.add("nav-open");
});

document.getElementById("close").addEventListener("click", function () {

    document.querySelector("body").classList.remove("nav-open");
});
var LOTTIE = document.getElementById("lottie-b");

var LOTTIE_PLACE_HOLDER = document.getElementById("lottie-holder-placeonly");
var LOTTIE_Y = null;
var LOTTIE_H = null;

var FIRST_DRAW = true;

var BODY=document.querySelector("body");
function positionLottie() {

    /*if (LOTTIE_RUNNED) {
        LOTTIE_Y = 0;
        LOTTIE_H = 100;
        return;
    }*/


    if(BODY.classList.contains("show_form") || BODY.classList.contains("show_regler")){

        LOTTIE_Y=0;
        LOTTIE_H=100;
        return;

    }
    var o = LOTTIE_PLACE_HOLDER.getBoundingClientRect();

    var section=LOTTIE_PLACE_HOLDER.parentNode.parentNode.parentNode;       
    var section_place = section.getBoundingClientRect();
    var org_from_top=o.y+o.height-section_place.y;
    var org_bottom=o.y-section_place.y+o.height;
    var cur_bottom=o.bottom;
    //console.log("org_bottom/cur_bottom",org_bottom,cur_bottom);
    LOTTIE_Y = o.y;
    LOTTIE_H= cur_bottom- LOTTIE_Y;
   

    if(LOTTIE_Y<0){
        LOTTIE_Y=0;
       
        LOTTIE_H+=o.y;
        if(LOTTIE_H<100){
            LOTTIE_H=100;
        }
        return;
    }
    if(cur_bottom<=org_bottom){
        


    }else{
        LOTTIE_Y=0;
        LOTTIE_H=100;
       
    }
    //console.log("parent",);

    return;


    var y = o.y;

    LOTTIE_Y = y;
   
    if (LOTTIE_Y < 0) {
        LOTTIE_Y = 0;
        LOTTIE_H=100;
        return;
    }
    LOTTIE_H = o.bottom - LOTTIE_Y;

    if (o.y > 0) {

        //LOTTIE_H=100;
        if (LOTTIE_H < 100) {
            LOTTIE_Y = 0;
            LOTTIE_H = 100;

        }
       
        return;
    }

    if (LOTTIE_H < 100) {
   
        LOTTIE_Y = 0;
        LOTTIE_H = 100;
    }

    return;
    if (LOTTIE_RUNNED) {

        if (true) {

            console.log("ANIS", o.y);
            LOTTIE_Y = 0;
            LOTTIE_H = o.height;
            return;
        } else {
            //return false;
        }
    }

    var h = LOTTIE_PLACE_HOLDER.getBoundingClientRect().height;

    if (y < 0) {
        y = 0;

        var diff = o.y;

        h = o.bottom;

        if (h < 100) {
            h = 100;
            LOTTIE_RUNNED = true;
        }

        console.log(h);
    }
    LOTTIE_Y = y;
    LOTTIE_H = h;
    //LOTTIE.style.top=y+"px";
    //LOTTIE.style.height=h+"px";

    //LOTTIE.style.position.left=o.x+"px";
    //LOTTIE.style.position.top=o.x+"px";
}
setInterval(function () {
    positionLottie();
}, 0);
var ANIS = [];
function positionTextAni(o) {
    var target_x;
    var target_y;
    if (o.hasAttribute("data-target")) {

        target_x = document.getElementById(o.getAttribute("data-target"));
        target_y = target_x;
    } else {
        target_x = document.getElementById(o.getAttribute("data-target-x"));
        target_y = document.getElementById(o.getAttribute("data-target-y"));
    }

    var pos_x = target_x.getBoundingClientRect();
    var pos_y = target_y.getBoundingClientRect();

    o.style.top = 0 + "px";
    var posme = o.getBoundingClientRect();

    var diff = pos_y.top - posme.top;
    var l = pos_x.x;
    // if(o.hasAttribute("data-target")){
    //  l+=target_x.width/2;
    l += pos_x.width / 2 - o.getBoundingClientRect().width / 2;

    // }
    l = 20;
    o.style.left = l + "px";
    o.style.top = diff + "px";
}
function makeTextAni(id) {
    var o = document.getElementById(id);
    positionTextAni(o);

    ANIS.push(o);
}
function makeAnis() {
    ANIS = [];
    makeTextAni("texts");
    makeTextAni("texts2");
}
function runAnis() {

    for (var i = 0; i < ANIS.length; i++) {

        var o = ANIS[i];
        positionTextAni(o);
        // var top=(o.getBoundingClientRect().y);
        // if(window.innerHeight/2>top){
        showImages(o.querySelectorAll("img"));
        // }
    }
}
function showImages(images) {

    for (var i = 0; i < images.length; i++) {

        var top = images[i].getBoundingClientRect().y;

        if (window.innerHeight / 2 > top) {
            images[i].classList.add("onscreen");
        } else {

            images[i].classList.remove("onscreen");
        }
    }
}
window.addEventListener("resize", function () {

    makeAnis();
});
window.addEventListener("scroll", function (e) {

    runAnis(e);
});
makeAnis();

function positionBurgers() {

    var ARROW_P = .90;
    var arrows = document.getElementById("down-holder");

    var arrows_pos = arrows.getBoundingClientRect();

    if (arrows_pos.y < window.innerHeight * ARROW_P) {

        var diff_total = window.innerHeight * ARROW_P - arrows_pos.y;
        // console.log("ani",diff_total);

        var p = diff_total / arrows_pos.height;
        for (var i = 0; i < 5; i++) {

            if (i / 5 < p) {
                arrows.children[i + 1].classList.add("show");
            } else {
                //  arrows.children[i+1].classList.remove("show");
            }
        }
    }

    var tracks = document.querySelectorAll("#burger-grid .burger-row");

    for (var i = 0; i < tracks.length; i++) {
        var s = 3;
        if (i % 2 == 0) {
            s = 4;
        }
        BURGER_TRACK_POSSES[i] -= s;
        // tracks[i].style.backgroundImage="url(/resources/images/bursat/"+img_name+".png)";

        tracks[i].style.backgroundPosition = BURGER_TRACK_POSSES[i] + "px 0px";
    }
    return;

    var burgers = document.getElementById("burger-grid");
    var pos = burgers.getBoundingClientRect();

    var p = 0;
    if (pos.top < 0) {
        var max = pos.height - window.innerHeight;

        var y = pos.bottom - window.innerHeight;

        if (y < 0) {
            y = 0;
            p = 1;
        } else {

            p = 1.0 - y / max;
        }
    } else {}

    for (var i = 0; i < burgers.children.length; i++) {
        // console.log(burgers.children[i].children[0].getBoundingClientRect().height)

        var h = burgers.children[i].children[0].getBoundingClientRect().height;
        var diff = pos.height - h;
        var y = diff * p;
        burgers.children[i].style.transform = "translateY(" + y + "px)";
        /* var h=burger_height*burgers.children[i].children.length;
        
         var diff=pos.height-h;
         var y= diff*p;
        */
        // burgers.children[i].style.transform="translateY("+y+"px)";
    }
}

var BURGER_TRACK_POSSES = [];
function redrawBurgers() {

    var tracks = document.querySelectorAll("#burger-grid .burger-row");
    var p = 1.5;
    var r = 250 / 173;

    var track_width = window.innerWidth;

    var burger_width = 200;

    var min_burgers = Math.ceil(track_width / burger_width) + 2;

    for (var i = 0; i < tracks.length; i++) {

        // var x= Math.random()*burger_width;
        var img_name = i % 3 + 1;

        BURGER_TRACK_POSSES[i] = -Math.random() * burger_width;
        tracks[i].style.backgroundImage = "url(/resources/images/bursat/" + img_name + ".png)";

        tracks[i].style.backgroundPosition = BURGER_TRACK_POSSES[i] + "px 0px";

        /* // for(var x=0;x<burger_count;x++){
             var img_name=(i % 3)+1;
              var img=document.createElement("img");
              img.src="/resources/images/bursat/"+img_name+".png";
              tracks[i].appendChild(img);
        //  }*/
    }
}
redrawBurgers();

var spos = {
    "bg1": [{ x: 220, y: 60, xd: .9, yd: 0, width: 200 }, { x: 60, y: 210, xd: .6, yd: 0, width: 200 }, { x: -20, y: 90, xd: .6, yd: 0, width: 200 }, { x: 800, y: 250, xd: .4, yd: 0, width: 200 }],
    "c1": { x: 60, y: 160, xd: .75, yd: 0, width: 120 },
    "c2": { x: -20, y: 90, xd: .5, yd: 0, width: 120 },

    "cloud-anis": [{ x: 10, y: 50, xd: .4, yd: 0, width: 200 }, { x: 300, y: 0, xd: .2, yd: 0, width: 200 }, { x: 740, y: 200, xd: .8, yd: 0, width: 200 }],

    "cloud-anis-2": [{ x: 10, y: 50, xd: .4, yd: 0, width: 200 }, { x: 300, y: 0, xd: .2, yd: 0, width: 200 }, { x: 800, y: 160, xd: .8, yd: 0, width: 200 }]

};
//background-position: 10px 50px,300px 0px,400px 200px;"

var POS_BTN_ANI_X=0;
function animateBgs() {


    if(STOP_BTN_ANI==false){
    POS_BTN_ANI_X--;
    var r=Math.abs(POS_BTN_ANI_X % 180);
    if(r==0){
      
        POS_BTN_ANI_X=0;

    }

    BTNANI.style.transform="translateX("+POS_BTN_ANI_X+"px)";


}
  
   
  




    if (LOTTIE_H !== null) {
        var now = LOTTIE.getBoundingClientRect();
        var dy = now.y + (LOTTIE_Y - now.y) * .05;
        var dh = now.height + (LOTTIE_H - now.height) * .25;

        if (FIRST_DRAW) {
            dy = LOTTIE_Y;
            dh = LOTTIE_H;
            FIRST_DRAW = false;
          
        }
        LOTTIE.style.top = dy + "px";
        LOTTIE.style.height = dh + "px";
    }

    for (var i in spos) {

        var s = document.getElementById(i);

        if (Array.isArray(spos[i])) {

            var str = "";
            for (var x = 0; x < spos[i].length; x++) {

                str += spos[i][x].x + "px " + spos[i][x].y + "px";

                if (spos[i][x].x > window.innerWidth) {
                    spos[i][x].x = -spos[i][x].width;
                }

                spos[i][x].x += spos[i][x].xd;
                spos[i][x].y += spos[i][x].yd;
                if (x + 1 != spos[i].length) {
                    str += ",";
                }
            }

            s.style.backgroundPosition = str;
        } else {
            s.style.backgroundPosition = spos[i].x + "px " + spos[i].y + "px";

            if (spos[i].x > window.innerWidth) {
                spos[i].x = -spos[i].width;
            }

            spos[i].x += spos[i].xd;
            spos[i].y += spos[i].yd;
        }
    }
}
var text_fields = ["name", "phone", "mail"];
function tryToSubmit() {

    var d = {};
    var cansend = true;
    for (var i = 0; i < text_fields.length; i++) {

        var o = document.getElementById(text_fields[i]);
        if (o.value.trim() == "") {
            o.parentNode.classList.add("error");
            cansend = false;
        }
        d[text_fields[i]] = o.value.trim();
    }
    var o = document.getElementById("reglerch");
    if (!o.classList.contains("checked")) {
        o.parentNode.parentNode.classList.add("error");
        cansend = false;
    }

    var o = document.getElementById("policy");
    if (!o.classList.contains("checked")) {
        o.parentNode.parentNode.classList.add("error");
        cansend = false;
    }

    d.policy = 1;
    d.regler = 1;

    if (cansend) {
        var form = document.getElementById("form");
        form.classList.add("loading");
        postData("submit.php", d).then(function (data) {
            if (data && data.status && data.status == "ok") {
                form.classList.add("thanks");
                window.scrollTo(0, 0);
                
            }
        });
    }
}
setInterval(function () {
    animateBgs();
}, 20);
document.getElementById("skicka").addEventListener("click", function (e) {

    e.preventDefault();
    tryToSubmit();
});

async function postData() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Default options are marked with *
    var response = await fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.

        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached

        headers: {
            "Content-Type": "application/json"
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
}

var boxes = document.querySelectorAll("span.box");
for (var i = 0; i < boxes.length; i++) {

    boxes[i].addEventListener("click", function (e) {
        e.currentTarget.parentNode.parentNode.classList.remove("error");
        if (e.currentTarget.classList.contains("checked")) {
            e.currentTarget.classList.remove("checked");
        } else {
            e.currentTarget.classList.add("checked");
        }
    });
}
for (var i = 0; i < text_fields.length; i++) {

    var o = document.getElementById(text_fields[i]);

    o.addEventListener("focus", function (e) {

        e.currentTarget.parentNode.classList.remove("error");
    });
}

var links = document.querySelectorAll(".goto");
function gotoPage(g) {

    document.querySelector("body").classList.remove("show_regler");
    document.querySelector("body").classList.remove("show_form");

    switch (g) {
        case "home":

            document.querySelector("body").classList.remove("nav-open");
            DUPLICATOR.resetToTop();
            

            window.scrollTo(0, 0);

        break;
        case "unga":

            document.querySelector("body").classList.remove("nav-open");
            DUPLICATOR.resetToTop();
            var yp = document.getElementById("unga-target").getBoundingClientRect().y;

            window.scrollTo(0, yp);
            break;
        case "om":

            document.querySelector("body").classList.remove("nav-open");

            DUPLICATOR.resetToTop();
            var y = document.getElementById("om-target").getBoundingClientRect().y;
            window.scrollTo(0, y);

            break;
        case "form":
            document.querySelector("body").classList.remove("nav-open");
            document.querySelector("body").classList.add("show_form");
            window.scrollTo(0, 0);

            break;
        case "regler":
            document.querySelector("body").classList.remove("nav-open");
            document.querySelector("body").classList.add("show_regler");
            window.scrollTo(0, 0);

            break;
            case "reglerperson":
                document.querySelector("body").classList.remove("nav-open");
                document.querySelector("body").classList.add("show_regler");
                window.scrollTo(0, 0);
                if(document.body.scrollHeight){
                    window.scrollTo(0, document.body.scrollHeight);
                }

            break;
    }
}
for (var i = 0; i < links.length; i++) {
    links[i].addEventListener("click", function (e) {
        if (e.currentTarget.hasAttribute("data-goto")) {

            gotoPage(e.currentTarget.getAttribute("data-goto"));
        }
    });
}

window.addEventListener("DOMContentLoaded", function (event) {

    setTimeout(function () {

        setInterval(function () {
            positionBurgers();
        }, 20);
    }, 1200);
});
//# sourceMappingURL=index.js.map
function stopAllVideos(){






    var videos=document.querySelectorAll("video");
    for(var i=0;i<videos.length;i++){

       
        var video=videos[i];        
        
        video.currentTime = 0;
        video.pause();
        video.parentNode.classList.remove("playing");

    }

    


}

function playPause(dom_ele){

    var mobile= dom_ele.querySelector("video.mobile");
    var desktop=dom_ele.querySelector("video.desktop");
    
     var video=(window.innerWidth<800?mobile:desktop);

   
    if(video.paused){
        video.play();
       
    }else{
        video.pause();
        
    }

}
function playVideo(dom_ele){

//alert(dom_ele.getAttribute("data-target"));

   
   var mobile= dom_ele.querySelector("video.mobile");
   var desktop=dom_ele.querySelector("video.desktop");
    
    var video=(window.innerWidth<800?mobile:desktop);

    stopAllVideos();

    dom_ele.classList.add("playing");
    video.play();

}
var play_buttons=document.querySelectorAll(".play-video-holder img");
for(var i=0;i<play_buttons.length;i++){


    play_buttons[i].addEventListener("click",function(e){

        playVideo(e.currentTarget.parentNode.parentNode);


    }); 


}

var videos=document.querySelectorAll("video");
for(var i=0;i<videos.length;i++){

    
    videos[i].addEventListener("click",function(e){

        playPause(e.currentTarget.parentNode);


    }); 


}



var videos=document.querySelectorAll("video");
for(var i=0;i<videos.length;i++){

    videos[i].addEventListener("ended", (event) => {
       
        stopAllVideos();

    });
}

var CURRENT_VIEW=null;

function updateView(){

    var r=180/53;

    MAIN.style.height="";

    var h=MAIN.getBoundingClientRect().height*2.2;
    MAIN.style.height=h+"px";
    var amount= Math.ceil(window.innerWidth/180)+1;
    BTNANI.innerHTML="";
   
    for(var i=0;i<amount;i++){

        var div=document.createElement("div");
        div.className="iholder";
        var img=document.createElement("img");
        img.src="/resources/images/Marquee-button-pink.svg";

        var img2=document.createElement("img");
        img2.src="/resources/images/Marquee-button-white.svg";
        img2.className="hover-image";
        div.appendChild(img);
        div.appendChild(img2);

        BTNANI.appendChild(div);
    }

    
    var view=(window.innerWidth<800?"mobile":"desktop");
    if(CURRENT_VIEW===null){

        CURRENT_VIEW=view;

        return;
    }else{
        if(CURRENT_VIEW!=view){

            stopAllVideos();
        }


        CURRENT_VIEW=view;


    }

}

var BTNANI=document.getElementById("btnani");
var STOP_BTN_ANI=false;

window.addEventListener("resize",function(){

    updateView();

   
});

BTNANI.addEventListener("mouseover",function(){
    STOP_BTN_ANI=true;
   

});
BTNANI.addEventListener("mouseleave",function(){
   
        STOP_BTN_ANI=false;
     
    
   
});

updateView();